var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3857dfcc1bb06e79b79b46def48f4f8c8e2fb248"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["dl@sanjow"]={id:"3857dfcc1bb06e79b79b46def48f4f8c8e2fb248"};
      